/***
 * Created on 2023/12/26
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";
import ic_admin_d_layer_svg from "../../static/img/content/ic-admin-d-layer.svg";

function MainContentSummaryRowAdminComponent({organization, userStatus, goAccountList}) {
    const { t } = useTranslation();

    return (
        <div className="col-summary col-admin col-with-attention flex-default !w-52">
            <div className="l-section">
                <div className="section-title">
                    <span className="ic"><img src={ic_admin_d_layer_svg} alt=""/></span>
                    <span className="label">{t('@Members@')}</span>
                </div>
                <div className="total-num" onClick={goAccountList}><span>{organization.administrators_count || 0}</span></div>
            </div>
            <div className="r-section">
                <ul className="summary-detail status-detail">
                    <li className="status-activate">
                        <div className="label">{t('@Active@')}:</div>
                        <div className="val">{userStatus.active}</div>
                    </li>
                    <li className="status-invited">
                        <div className="label">{t('@Invited@')}:</div>
                        <div className="val">{userStatus.pending || 0}</div>
                    </li>
                    <li className="status-qid-not-activate">
                        <div className="label">{t('@QID not activated@')}:</div>
                        <div className="val">{userStatus.qid_not_activated || 0}</div>
                    </li>
                    <li className="status-suspended">
                        <div className="label">{t('@Suspended@')}:</div>
                        <div className="val">{userStatus.suspend || 0}</div>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default MainContentSummaryRowAdminComponent;